import StoredTranslationData from './store/schema/StoredTranslationData';
import { ClientItem } from 'owa-mail-store';

export default {
    InlineTranslationMessageTranslated: {
        name: 'InlineTranslationMessageTranslated',
        cosmosOnlyData: (itemId: string, subject: string) => itemId,
    },

    InlineTranslationMessageUntranslated: {
        name: 'InlineTranslationMessageUntranslated',
        cosmosOnlyData: (itemId: string) => itemId,
    },

    InlineTranslationStoreData: {
        name: 'InlineTranslationStoreData',
        cosmosOnlyData: (itemId: string, data: StoredTranslationData) => itemId,
    },

    InlineTranslationStoreStatus: {
        name: 'InlineTranslationStoreStatus',
        cosmosOnlyData: (itemId: string, isShowingTranslation: boolean) => itemId,
    },

    InlineTranslationLoadDataAndStatus: {
        name: 'InlineTranslationLoadDataAndStatus',
        cosmosOnlyData: (item: ClientItem) => item.ItemId.Id,
    },
};
